export const ANONYMOUS_USER_TOKEN_LS_KEY = 'anonymous_user_token'
